import { useData } from '@hooks/useData';
import http from '@core/fetch';
import apiConfig from '@apiConfig';
import { components } from '@apiSchema';

export type OpeningClosingFilter = components['schemas']['OpeningClosingFilter'];

const REQUEST_TYPE: keyof typeof apiConfig = 'get opening closing filters';
const DEFAULT_DATA: OpeningClosingFilter[] = [];

const getOpeningClosingFilters = async (): Promise<OpeningClosingFilter[]> => {
    const response: OpeningClosingFilter[] = await http.get(REQUEST_TYPE);
    return response ?? [];
};

export const useOpeningClosingFilters = () => useData(DEFAULT_DATA, getOpeningClosingFilters);
